<template>
    <OverlayLoader :isLoading="!isLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="`${this.$translate.text('general.attributes')} ( ${connectionName} )`"
                />

                <ConnectionMenu></ConnectionMenu>

                <WhiteTable :labels="[$translate.text('general.brand'), $translate.text('general.categories'), $translate.text('general.product_group')]">
                    <template slot="table-data">
                        <tr v-for="attribute in attributes" :key="attribute.id">
                            <td style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 1px; width: 30%;">{{ flattenBrands(attribute.brands) }}</td>
                            <td style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 1px; width: 30%;">{{ flattenCategories(attribute.categories) }}</td>
                            <td style="width: 30%;">{{ attribute.property_group }}</td>
                            <td class="align-right" style="width: 10%;">
                                <i class="fal fa-edit" @click="$router.push({ name: 'Clients Connections Attributes Edit', params: { id: $route.params.id, attribute_id: attribute.id } })" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                <i class="fal fa-trash-alt" @click="deleteAttribute(attribute.id)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                            </td>
                        </tr>
                        <tr v-if="!attributes.length">
                            <td colspan="6">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>

            <FloatingButton
                @clicked="$router.push({ name: 'Clients Connections Attributes Add' })"
            />
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';
import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';

export default {
    name: 'Attributes',

    components: {
        ConnectionMenu,
        PageHeader,
        OverlayLoader,
        WhiteTable,
        FloatingButton,
    },

    data() {
        return {
            attributes: [],
            connectionName: '',
            loaded: {
                items: {
                    attributes: false,
                    connection: false,
                },
            },

        };
    },

    created() {
        this.getAttributes();
        this.getConnection();
    },

    methods: {
        getAttributes() {
            this.API.clients.connections.attributes.index(this.$route.params.id)
                .then((response) => {
                    this.attributes = response.data.data;
                    this.loaded.items.attributes = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        deleteAttribute(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.API.clients.connections.attributes.destroy(this.$route.params.id, id)
                        .then(() => {
                            this.getAttributes();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    const connection = response.data.data.name;


                    this.connectionName = connection;

                    this.loaded.items.connection = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        flattenBrands(brands) {
            if (brands === null) {
                return '*';
            }

            const joins = [];

            brands.forEach(category => {
                joins.push(category.label);
            });

            return joins.join(', ');
        },

        flattenCategories(categories) {
            if (categories === null) {
                return '*';
            }

            const joins = [];

            categories.forEach(category => {
                joins.push(category.label);
            });

            return joins.join(', ');
        },
    },

    computed: {
        isLoaded() {
            return this.loaded.items.attributes && this.loaded.items.connection;
        },
    },
};
</script>

<style scoped>
    .white-table {
        padding-top: 20px;
    }
</style>
